<template>
  <layout
    :key="uniquePageKey"
    :header="header"
    :footer="footer"
    :country="country"
    :hide-usps="true"
    :show-breadcrumbs="false"
  >
    <div>
      <loading v-if="$fetchState.pending" />
      <carriers
        v-if="carriersData"
        :carriers-data="carriersData"
        :direction="direction"
        :allowed-countries="taxon.countries"
      />
    </div>
    <portal-target :name="portals.PORTAL_NAME_SWITCH_COUNTRY" />
    <portal-target :name="portals.PORTAL_SUGGESTION_COUNTRY" />
  </layout>
</template>

<script>
import { Carriers } from '@/components/pages'
import createPageMixin from '@/mixins/page'
import {
  CARRIERS_PAGE,
  MOBILE_TOPUP,
  SECONDARY_PAGE,
} from '@/utils/constants/category-brand-legal'
import { firstOfCollection } from '@/utils/collection'
import { contentfulToImage, recommerceToImageByType } from '@/utils/image'
import isEmpty from '@/utils/isEmpty'
import Layout from '~/components/layout/default'
import { Loading } from '~/components/organisms'
import { portals } from '~/enums'

export default {
  name: 'CarriersPage',
  components: {
    Layout,
    Loading,
    Carriers,
  },
  mixins: [
    createPageMixin({ pageType: SECONDARY_PAGE, cloudfrontCache: true }),
  ],
  data() {
    return {
      taxon: null,
      portals,
    }
  },
  async fetch() {
    try {
      await Promise.all([
        this.fetchCMSCarriersPageData(),
        this.fetchCarriersData(),
      ])
    } catch (e) {
      this.$sentry.captureException(e)
      this.$nuxt.error({ statusCode: 500, message: e.message })
    }
  },
  computed: {
    carriersData() {
      if (isEmpty(this.contentfulPageData) || !this.taxon) return null
      const heroBanner = this.getSection('SectionHeroBanner')
      if (!heroBanner) return null
      return {
        sectionCategoryBanner: {
          image: contentfulToImage(heroBanner.banner),
          imageMobile: contentfulToImage(heroBanner.bannerMobile),
          showBreadcrumbs: true,
          title: heroBanner.title,
        },
        sectionBrandList: [
          {
            brands: this.taxon.products.map(product => ({
              logo: recommerceToImageByType(product, 'product_card'),
              slug: product.slug,
              title: product.nameInCategoryPage || product.name,
              countries: product.countries,
            })),
            categoryPage: { slug: this.contentfulPageData.slug },
          },
        ],
        slug: this.taxon.slug,
        appBanner: this.getSection('SectionAppBanner'),
      }
    },
  },
  methods: {
    async fetchCarriersData() {
      const data = await this.$recommerce('taxonBySlug')({
        taxonSlug: MOBILE_TOPUP,
      })

      if (data === null) return

      this.taxon = data
    },
    async fetchCMSCarriersPageData() {
      const { data: legalPageResponse } = await this.$contentful('legalPage')({
        slug: CARRIERS_PAGE,
        locale: this.$store.getters['context/cmsLocale'],
      })
      const legal = firstOfCollection(legalPageResponse.legalPageCollection)

      if (!legal) return

      this.contentfulPageData = legal
    },
  },
}
</script>
